export const GAME_TITLE = "Black Connections";
export const MAX_MISTAKES = 4;
